import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { allProducts } from "./product.thunk";

const init_product = {
  product: -1,
  search: "",
  loading: false,
  meta:{}
};

export const fetchAllProductsAsyncThunk = createAsyncThunk(
  "fetchAllProducts",
  allProducts
);

const productSlice = createSlice({
  name: "products",
  initialState: init_product,
  reducers: {
    setAllProduct: (state, action) => {
      state.product = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    setMeta: (state,action)=>{
      state.meta = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllProductsAsyncThunk.pending, (state) => {
        state.loading = true;
        return state;
      })
      .addCase(fetchAllProductsAsyncThunk.fulfilled, (state) => {
        state.loading = false;
        return state;
      })
      .addCase(fetchAllProductsAsyncThunk.rejected, (state) => {
        state.loading = false;
        return state;
      });
  },
});

export const { setAllProduct, setSearch, setMeta } = productSlice.actions;
export default productSlice.reducer;
